/**
 * 入住人数
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { moduleClick } from "@shared/lingxi/core";
import InputNumber from "@components/input-number";

class GuestCount extends Component {
  render() {
    const { max, value, onChange, productId } = this.props;
    return (
      <div className="search-menu__guest-count search-menu">
        <div className="search-menu__label">
          <label>入住人数</label>
          <InputNumber
            max={max}
            min={1}
            input={{
              value,
              name: "",
              onChange: v => {
                onChange(v);
                moduleClick("设置入住人数", {
                  goods_id: productId,
                });
              },
            }}
          />
        </div>
      </div>
    );
  }
}

GuestCount.propTypes = {
  max: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

GuestCount.defaultProps = {
  max: Infinity,
  value: 1,
};

export default GuestCount;

require("./index.less");